/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

function ParseTag(rawTag) {
  var fullParts = rawTag.split('_');
  var tag = fullParts.slice(1).join('_');
  var tagType = fullParts[0];
  var tagParts = fullParts.slice(1);
  if (tagType !== "make" && tagType !== "model" && tagType !== "submodel") {
    return {make: null, model: null, submodel: null}
  }
  
  var make = null;
  var model = null;
  var submodel = null;
  if (tagParts.length >= 1) {
    make = tagParts[0].toLowerCase(); 
  }
  if (tagParts.length >= 2) {
    model = tagParts[1].toLowerCase();
    console.log("Model");
  }
  if (tagParts.length >= 3) {
    submodel = tagParts[2].toLowerCase();
    console.log("SubModel");
  }
  return {make: make, model: model, submodel: submodel}
}

function Matches(activeFilters, filterTag) {
  if (activeFilters.make && filterTag.model !== null && filterTag.make !== null && filterTag.make !== activeFilters.make) {
    return false;
  }

  if (activeFilters.model && filterTag.submodel !== null && filterTag.model !== null && filterTag.model !== activeFilters.model) {
    return false;
  }

  return true;
}

function IsValidTag(rawTag) {
  var fullParts = rawTag.split('_');
  var tag = fullParts.slice(1).join('_');
  var tagType = fullParts[0];
  var tagParts = fullParts.slice(1);
  if (tagType !== "make" && tagType !== "model" && tagType !== "submodel") {
    return true;
  }

  if (tagType === "make") {
    return tagParts.length == 1;
  }

  if (tagType === "model") {
    return tagParts.length == 2;
  }

  return tagParts.length == 3;
}

function ActiveFilters() {
  var activeFilters = document.querySelectorAll(".collection__active-filter-item button");    
  var active = {};
  for (var i = 0; i < activeFilters.length; i++) {
    var activeFilter = activeFilters[i];
    var tag = activeFilter.getAttribute("data-tag");    
    var tagParts = tag.split('_');
    active[tagParts[0]] = tagParts[tagParts.length - 1];
  }
  return active;
}

function UpdateFilter() {
  var checkBoxes = document.querySelectorAll(".collection__filter-checkbox .checkbox-wrapper input[type=checkbox]");  
  var active = ActiveFilters();
  
  for (var i = 0; i < checkBoxes.length; i++) {
    var wrapper = checkBoxes[i].parentElement.parentElement;
    wrapper.classList.remove('d-hidden');
  }

  for (var i = 0; i < checkBoxes.length; i++) {
    var wrapper = checkBoxes[i].parentElement.parentElement;
    var shouldDisplay = true;
    var tag = checkBoxes[i].getAttribute("data-tag");
    var parseTag = ParseTag(tag);
    if (parseTag.model !== null) {
      console.log("Found It");
    }
    if (!Matches(active, parseTag) || !IsValidTag(tag)) {
      wrapper.classList.add('d-hidden');
    }
  }
}

document.addEventListener('theme:loading:end', () => {
  UpdateFilter();
});